import { poisBountyAssets } from "assets/cdn";

export interface LearnMoreItem {
	image: string;
	title: string;
	description?: string;
}

export const itemsV1: LearnMoreItem[] = [
	{
		image: poisBountyAssets.tutorial.panelOne,
		title: "Make purchases in the Web Shop",
		description:
			"Purchase items in the shop during the event to collect Loyalty Points."
	},
	{
		image: poisBountyAssets.tutorial.panelTwo,
		title: "Collect Loyalty Points",
		description:
			"Loyalty Points from your purchases will be reflected in the Poi's Bounty Meter."
	},
	{
		image: poisBountyAssets.tutorial.panelThree,
		title: "Collect Rewards from Poi!",
		description:
			"After you claim your rewards on the website, visit your TriPeaks Inbox to collect them!"
	}
];

export const itemsV2: LearnMoreItem[] = [
	{
		image: poisBountyAssets.v2.ftue.loyalty.first,
		title: "Make purchases in the Web Shop",
		description:
			"Purchase items in the shop during the event to collect Loyalty Points."
	},
	{
		image: poisBountyAssets.v2.ftue.loyalty.second,
		title: "Collect Loyalty Points",
		description:
			"Loyalty Points from your purchases will be reflected in the Poi's Bounty Meter."
	},
	{
		image: poisBountyAssets.v2.ftue.loyalty.third,
		title: "Claim Rewards & Keep Going",
		description:
			"Once your meter is filled, claim your rewards & keep advancing until the event concludes."
	}
];
